<script>
export default {
  name: "l-dialog",
  props: {
    title: {
      type: String,
      default: '提示'
    },
    // show: {
    //   type: Boolean,
    //   default: false
    // },
    width: {
      type: String,
      default: '30%'
    }
  },
  data() {
    return {
      show: false,
    }
  },
  methods: {
    handleClose(done) {
      this.show = false;
      this.$emit('handleClose')
    },
    handleOpen() {
      this.show = true;
    }
  }
}
</script>

<template>
  <el-dialog :title="title" :visible.sync="show" :width="width" :before-close="handleClose" :center="true">
    <div>
      <slot name="top"></slot>
      <slot name="bottom">
        <el-button @click="show = false">取 消</el-button>
        <el-button type="primary" @click="show = false">确 定</el-button>
      </slot>
    </div>
  </el-dialog>
</template>

<style scoped lang="scss">
::v-deep .el-dialog {
  border-radius: 16px;
}
</style>